import React from "react";
import { ConstructionProjectOutsourcingModal } from "../services/construction/ConstructionProjectOutsourcingModal";
import { FacilityMaintenanceOutsourcingModal } from "../services/facility-maintenance/FacilityMaintenanceOutsourcingModal";
import { RenovationProjectOutsourcingModal } from "../services/renovations/RenovationProjectOutsourcingModal";

interface ProjectOutsourcingModalProps {
  isOpen: boolean;
  onClose: () => void;
  userType: "business" | "homeowner";
  serviceType: "construction" | "facility-maintenance" | "renovations";
}
export const ProjectOutsourcingModal: React.FC<ProjectOutsourcingModalProps> =
  ({ isOpen, onClose, userType, serviceType }) => {
    if (!isOpen) return null;

    if (serviceType === "construction") {
      return (
        <ConstructionProjectOutsourcingModal
          isOpen={isOpen}
          onClose={onClose}
          userType={userType}
        />
      );
    }

    if (serviceType === "facility-maintenance") {
      return (
        <FacilityMaintenanceOutsourcingModal
          isOpen={isOpen}
          onClose={onClose}
          userType={userType}
        />
      );
    }

    return (
      <RenovationProjectOutsourcingModal
        isOpen={isOpen}
        onClose={onClose}
        userType={userType}
      />
    );
  };